import React from 'react'
import styles from './MapPicker.scss'
import { Button } from 'common/Button'

const Ride = ({ ride, onClick }) => (
  <li onClick={onClick} className={styles.Ride}>
    <img src={`/trips/thumb/${ride.get('id')}.png`} />
    <p>{ride.get('name')}</p>
  </li>
)

export const MapPicker = ({ onChange, rides, cancelable, onCancel, prompt }) => (
  <div className={styles.MapPicker}>
    {prompt || <h2>Pick a map to insert</h2>}

    <ul>
      {rides.map(r => <Ride ride={r}
        key={r.get('id')}
        onClick={e => onChange({ rideId: r.get('id') })} />)
        .toArray()
      }
    </ul>
    {cancelable && <Button type='default' onClick={onCancel}>cancel</Button>}
  </div>
)
